import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import style from './style.module.less';

const unknown = 'unknown';
const invalidCodeResponse = 'Invalid verification code';

const getFriendlyIntlRejection = (rejectionReason) => {
  switch (rejectionReason) {
    case invalidCodeResponse:
      return (
        <FormattedMessage
          defaultMessage='Verification code was not valid, please try again.'
          description='phoneVerifyModal.invalidCode'
          id='88Dkvh'
        />
      );
    case unknown:
      return (
        <FormattedMessage
          defaultMessage='Something went wrong, please try again.'
          description='phoneVerifyModal.unknownError'
          id='pI4mKu'
        />
      );
    default:
      return rejectionReason;
  }
};

const ErrorMessage = ({ errorMessage }) => {
  const friendlyIntlError = getFriendlyIntlRejection(errorMessage);
  return <div className={style.error}>{friendlyIntlError}</div>;
};

ErrorMessage.propTypes = {
  errorMessage: PropTypes.string,
};

export default ErrorMessage;
